export default __webpack_public_path__ + "static/media/slider_3.909405d4.png";